import { render, staticRenderFns } from "./BannerPrice.vue?vue&type=template&id=34e93100&scoped=true"
import script from "./BannerPrice.vue?vue&type=script&lang=js"
export * from "./BannerPrice.vue?vue&type=script&lang=js"
import style0 from "./BannerPrice.vue?vue&type=style&index=0&id=34e93100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e93100",
  null
  
)

export default component.exports